import { inject, Injectable } from '@angular/core';
import { LocalStorageKeyEnum } from '../enums';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  readonly localStorageService = inject(LocalStorageService);

  get isSessionExpired(): boolean {
    return !!this.localStorageService.getItem(LocalStorageKeyEnum.IsSessionExpired);
  }

  set isSessionExpired(value: boolean) {
    this.localStorageService.setItem(LocalStorageKeyEnum.IsSessionExpired, value);
  }

  set authToken(token: string | null) {
    if (token === null) {
      this.localStorageService.removeItem(LocalStorageKeyEnum.AuthToken);
      return;
    }
    this.localStorageService.setItem(LocalStorageKeyEnum.AuthToken, token);
  }

  get authToken(): string | null {
    return this.localStorageService.getItem(LocalStorageKeyEnum.AuthToken);
  }

  set isCookiePolicyClosed(value: boolean) {
    this.localStorageService.setItem(LocalStorageKeyEnum.IsCookiePolicyClosed, value);
  }

  get isCookiePolicyClosed(): boolean {
    return !!this.localStorageService.getItem(LocalStorageKeyEnum.IsCookiePolicyClosed);
  }
}
